import { render, staticRenderFns } from "./AudioMsgRecorder.vue?vue&type=template&id=47fbebe2&scoped=true&lang=pug&"
import script from "./AudioMsgRecorder.vue?vue&type=script&lang=js&"
export * from "./AudioMsgRecorder.vue?vue&type=script&lang=js&"
import style0 from "./AudioMsgRecorder.vue?vue&type=style&index=0&id=47fbebe2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fbebe2",
  null
  
)

export default component.exports